"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var createSvgIcon_1 = __importDefault(require("../createSvgIcon"));
exports.default = (0, createSvgIcon_1.default)(react_1.default.createElement("g", null,
    react_1.default.createElement("circle", { cx: "8", cy: "8", r: "2" }),
    react_1.default.createElement("circle", { cx: "2", cy: "8", r: "2" }),
    react_1.default.createElement("circle", { cx: "14", cy: "8", r: "2" })), 'MenuDots');
//# sourceMappingURL=index.js.map